import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin, Shield, Wrench, Smartphone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1C1C1F] text-[#B5B5B5] border-t border-[#2A2A2D]">
      {/* Seção de Destaque */}
      <div className="bg-[#2A2A2D] border-b border-[#3A3A3D]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <h3 className="text-cinzel text-2xl font-bold text-[#EAEAEA] mb-3 uppercase tracking-wider">
              MULTICELL
            </h3>
            <p className="text-[#EAEAEA] text-base max-w-3xl mx-auto leading-relaxed">
              <span className="text-[#C9A24D] font-semibold">Referência em celulares premium</span>, acessórios de alto padrão 
              e <span className="text-[#C9A24D] font-semibold">assistência técnica especializada</span> para quem busca qualidade e confiança.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo e Descrição */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-4 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_open-ideas-2/artifacts/dgveb35o_ChatGPT%20Image%2022%20de%20jan.%20de%202026%2C%2011_58_47.png" 
                alt="MULTICELL" 
                className="h-14 w-14 object-contain rounded-full border border-[#C9A24D] glow-gold"
              />
              <span className="text-3xl font-bold text-cinzel tracking-wider text-metallic">
                MULTICELL
              </span>
            </div>
            
            {/* Nossos Serviços */}
            <div className="space-y-4 mb-6">
              <div className="flex items-start gap-3">
                <Smartphone className="h-5 w-5 text-[#C9A24D] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-[#EAEAEA] font-semibold text-sm">Vendas Premium</p>
                  <p className="text-[#B5B5B5] text-xs">Celulares de alto padrão e acessórios originais</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <Wrench className="h-5 w-5 text-[#C9A24D] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-[#EAEAEA] font-semibold text-sm">Assistência Técnica</p>
                  <p className="text-[#B5B5B5] text-xs">Reparos especializados com garantia</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <Shield className="h-5 w-5 text-[#C9A24D] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-[#EAEAEA] font-semibold text-sm">Atendimento Local</p>
                  <p className="text-[#B5B5B5] text-xs">Serviço rápido na sua região</p>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-[#2A2A2D] border border-[#3A3A3D] hover:border-[#C9A24D] rounded-lg flex items-center justify-center transition-all hover:glow-gold">
                <Facebook className="h-5 w-5 text-[#B5B5B5] hover:text-[#C9A24D] transition-colors" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#2A2A2D] border border-[#3A3A3D] hover:border-[#C9A24D] rounded-lg flex items-center justify-center transition-all hover:glow-gold">
                <Instagram className="h-5 w-5 text-[#B5B5B5] hover:text-[#C9A24D] transition-colors" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#2A2A2D] border border-[#3A3A3D] hover:border-[#C9A24D] rounded-lg flex items-center justify-center transition-all hover:glow-gold">
                <Twitter className="h-5 w-5 text-[#B5B5B5] hover:text-[#C9A24D] transition-colors" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-cinzel text-lg font-bold mb-6 text-[#EAEAEA] uppercase tracking-wider">
              Links Rápidos
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#B5B5B5] hover:text-[#C9A24D] transition-colors text-sm">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/catalogo" className="text-[#B5B5B5] hover:text-[#C9A24D] transition-colors text-sm">
                  Catálogo Premium
                </Link>
              </li>
              <li>
                <Link to="/carrinho" className="text-[#B5B5B5] hover:text-[#C9A24D] transition-colors text-sm">
                  Carrinho
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-cinzel text-lg font-bold mb-6 text-[#EAEAEA] uppercase tracking-wider">
              Contato
            </h3>
            <ul className="space-y-4 text-[#B5B5B5]">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-[#C9A24D] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-semibold text-[#EAEAEA]">(43) 99696-3570</p>
                  <p className="text-xs">Atendimento via WhatsApp</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-[#C9A24D] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm">contato@multicell.com</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[#C9A24D] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm">Paraná, Brasil</p>
                  <p className="text-xs text-[#C9A24D]">Atendimento Regional</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2A2A2D] mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#666] text-sm">
              © 2025 MULTICELL. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4 text-xs uppercase tracking-wider">
              <span className="text-[#C9A24D]">■</span>
              <span className="text-[#666]">Loja Premium</span>
              <span className="text-[#C9A24D]">■</span>
              <span className="text-[#666]">Assistência Técnica</span>
              <span className="text-[#C9A24D]">■</span>
              <span className="text-[#666]">Atendimento Local</span>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Bottom Line */}
      <div className="h-1 bg-gradient-to-r from-transparent via-[#C9A24D] to-transparent opacity-30"></div>
    </footer>
  );
};

export default Footer;
